module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Standard-3.1d860bf8.png";